import { Outlet } from 'react-router-dom';

import FollowerLayout from '@/components/layouts/FollowerLayout';

export default function FollowerNav() {
  return (
    <>
      <FollowerLayout>
        <Outlet />
      </FollowerLayout>
    </>
  );
}
